import React, { useEffect, useState } from 'react';
import IconCollection from '../../../IconCollection/IconCollection';
import './EventActionLogs.css'
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import Loading from '../../../Component/Loading/Loading';
import CustomDropdown from '../../../Component/CustomDropdown/CustomDropdown';
import toast from 'react-hot-toast';
import LogTimer from '../../../Component/LogTimer/LogTimer';
import { useMutation } from 'react-query';
import { gameData, submitPlayersAndMatchData, updateSLNo, updateSLNoPayload } from '../../../redux/reducers/playersReducer';
import { setMinutesLog, setQuarterLog, setSecondsLog } from '../../../redux/reducers/logReducer';
import ErrorPage from '../../../Component/Error/Error';

const EventActionLogs = () => {
  const eventType = useSelector((state) => state?.settingReducer?.General?.eventType);
  const eventType5x5DefaultTimer = useSelector((state) => state?.settingReducer?.General?.fiveXFive?.defaultTimerPerPeriod);
  const eventType5x5OvertimeTimer = useSelector((state) => state?.settingReducer?.General?.fiveXFive?.defaultTimerPerOvertime);
  const eventType3x3DefaultTimer = useSelector((state) => state?.settingReducer?.General?.threeXThree?.defaultTimerPerPeriod);
  const eventType3x3OvertimeTimer = useSelector((state) => state?.settingReducer?.General?.threeXThree?.defaultTimerPerOvertime)
  const playersReducer = useSelector((state) => state?.playersReducer);
  const { teamOneColor, teamTwoColor, sl_no } = playersReducer;
  const matchData = useSelector((state) => state?.playersReducer?.matchData);
  const game_data = useSelector((state) => state?.playersReducer?.matchData?.game_data);
  const game_subs = useSelector((state) => state?.playersReducer?.matchData?.game_subs);
  const logReducer = useSelector((state) => state?.logReducer)
  const { minutes, seconds, quarterLog } = logReducer
  const teamOneName = matchData?.team_a_short_name;
  const teamTwoName = matchData?.team_b_short_name;
  const event_team_a_id = matchData?.event_team_a_id;
  const event_team_b_id = matchData?.event_team_b_id;
  const event_id = matchData?.event_id;
  const event_group_id = matchData?.event_group_id;
  const currentQuarter = matchData?.game_status?.period;

  const { quarterOptions } = playersReducer;
  const filterQuarterOptions = (quarterOptions) => {
    return quarterOptions?.filter(option => {
      const values = ["NotStarted", "Final"];
      return !values.includes(option.value);
    });
  };

  useEffect(() => {
    const filteredOptions = filterQuarterOptions(quarterOptions) || []; // Fallback to empty array
    setSelectedQuarters([
      ...filteredOptions.map(option => option.value),
      'foul'
    ]);
  }, [quarterOptions]);


  // Find the maximum sl_no and update it
  useEffect(() => {
    if (matchData) {
      const scoreList = matchData?.game_data?.scoreList || [];
      const maxSlNo = scoreList.reduce((max, score) => Math.max(max, score.sl_no), 0);

      // Only set quarterLog if it is not already set
      if (!quarterLog) {
        dispatch(setQuarterLog(currentQuarter));
      }
      dispatch(updateSLNoPayload(maxSlNo));
    }
  }, [matchData]);

  let game_log = [];

  if (Array.isArray(game_subs)) {
    const scoreList = Array.isArray(game_data?.scoreList) ? game_data.scoreList : [];
    game_log = [...game_subs, ...scoreList];
  }

  const dispatch = useDispatch()
  const eventID = localStorage.getItem('eventID')
  const token = window.localStorage.getItem("token");
  const [selectLog, setSelectLog] = useState(null);
  const [loading, setLoading] = useState(false)
  const [selectLogTeamTwo, setSelectLogTeamTwo] = useState(null);
  const [userActionSelect, setUserActionSelect] = useState()
  const [userTwoActionSelect, setUserTwoActionSelect] = useState()
  const [teamOnePlayerSelect, setTeamOnePlayerSelect] = useState()
  const [teamTwoPlayerSelect, setTeamTwoPlayerSelect] = useState()
  const [isSelectAllChecked, setIsSelectAllChecked] = useState(true);
  const [team, setTeam] = useState('team1')
  const [scoreDeleteModal, setScoreDeleteModal] = useState(false)
  const [scoreId, setScoreId] = useState(null)
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [selectedQuarters, setSelectedQuarters] = useState(() => {
    const filteredOptions = filterQuarterOptions(quarterOptions) || []; // Ensure it's an array
    return [
      ...filteredOptions.map(option => option.value),
      'foul'
    ];
  });


  useEffect(() => {
    // Ensure that filterQuarterOptions returns an array or fallback to an empty array
    const allQuarters = (filterQuarterOptions(quarterOptions) || []).map(option => option.value);
    const allSelected = allQuarters.every(q => selectedQuarters.includes(q)) && selectedQuarters.includes('foul');
    setIsSelectAllChecked(allSelected);
  }, [selectedQuarters, quarterOptions]);

  async function getEventData(token) {
    try {
      const apiUrl = `${process.env.REACT_APP_API_ROOT}/api/get_event/${eventID}/`;
      const response = await axios.get(apiUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    } catch (error) {
      console.error("Error:", error);
      throw error; // Re-throw the error to handle it elsewhere if needed
    }
  }

  async function fetchEventData(token) {
    try {
      const eventData = await getEventData(token);


      dispatch(submitPlayersAndMatchData(eventData))

    } catch (error) {
      console.error("Error fetching event data:", error);
    }
  }

  useEffect(() => {
    fetchEventData(token);
  }, [eventID]);


  const handleSelectLogTeamOne = (value) => {
    if (value.type) {
      if (selectLog?.data_id === value.data_id) {
        setSelectLogTeamTwo(null);
        setTeam('team1');
        setUserTwoActionSelect();
        setTeamTwoPlayerSelect();

      } else {
        setSelectLog(value);
        setSelectLogTeamTwo(null);
      }
    } else {
      toast.error('You cannot delete or edit substitution')
    }

  }
  const handleSelectLogTeamTwo = (value) => {
    if (value.type) {
      if (selectLogTeamTwo?.data_id === value.data_id) {
        setSelectLogTeamTwo(null);
        setTeam('team2');
        setUserTwoActionSelect();
        setTeamTwoPlayerSelect();
      } else {
        setSelectLogTeamTwo(value);
        setSelectLog(null);
      }
    } else {
      toast.error('You cannot delete or edit substitution')
    }

  }
  const handleButtonClick = (action) => {
    if (userActionSelect === action) {
      setUserActionSelect(null);
    } else {
      setUserActionSelect(action);
    }
  };

  const handleButtonClickTwo = (action) => {
    if (userTwoActionSelect === action) {
      setUserTwoActionSelect(null);
    } else {
      setUserTwoActionSelect(action);
    }
  };


  const handleTeamOnePlayerSelect = (playerId) => {
    if (teamOnePlayerSelect === playerId) {
      setTeamOnePlayerSelect(null);
    } else {
      setTeamOnePlayerSelect(playerId);
    }
  };

  const handleTeamTwoPlayerSelect = (playerId) => {
    if (teamTwoPlayerSelect === playerId) {
      setTeamTwoPlayerSelect(null);
    } else {
      setTeamTwoPlayerSelect(playerId);
    }
  };

  const handleActionEditPlayer = (event_id, r_id, score_id) => {
    if (r_id) {
      setLoading(true);
      const headers = {
        'Authorization': token,
        'Content-Type': 'multipart/form-data',
      };
      const data = {
        event_id: event_id,
        r_id: r_id,
        score_id: score_id
      }
      axios.post(`${process.env.REACT_APP_API_ROOT}` + '/api/edit_score/', data, { headers })
        .then(response => {

          if (response.status === 200) {

            dispatch(gameData(response.data.game_data));

            toast.success('Score Edit successfully')
            setSelectLogTeamTwo(null)
            setTeamTwoPlayerSelect()
            setSelectLog(null)
            setTeamOnePlayerSelect()
            setLoading(false)

            // Call stats APIs after successful score edit
            callEventStats();

          }

        })
        .catch(error => {
          console.error('Error making POST request:', error);
        });
    } else {
      toast.error('Please select any Player')
    }



  }


  const teamScores = {};
  function formatTimeFromSeconds(seconds) {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    const formattedTime = `${minutes}:${remainingSeconds < 10 ? '0' : ''}${remainingSeconds}`;
    return formattedTime;
  }
  game_data?.scoreList?.forEach(score => {
    const teamId = score.t_id.toString();
    if (!teamScores.hasOwnProperty(teamId)) {
      teamScores[teamId] = [];
    }
    teamScores[teamId].push(score);
  });

  const filteredMatchData = game_log?.filter((match) => {
    const trimmedPeriod = match?.score_period.trim();
    const periodCondition = selectedQuarters?.includes(trimmedPeriod);
    const foulTypes = ['personalFoul', 'foulDrawn', 'technicalFoul'];
    const foulCondition = selectedQuarters?.includes('foul') && foulTypes.includes(match.score_type);
    return periodCondition || foulCondition;
  });

  const handleCheckboxChange = (event) => {
    const { id, checked } = event.target;
    if (id === "selectAll") {
      if (checked) {
        const allQuarters = filterQuarterOptions(quarterOptions).map(option => option.value);
        setSelectedQuarters([...allQuarters, 'foul']);
        setIsSelectAllChecked(true);
      } else {
        setSelectedQuarters([]);
        setIsSelectAllChecked(false);
      }
    } else if (id === "foul") {
      setSelectedQuarters(prevSelected => {
        if (checked) {
          return [...prevSelected, 'foul'];
        } else {
          return prevSelected.filter(q => q !== 'foul');
        }
      });
    } else {
      setSelectedQuarters(prevSelected => {
        if (checked) {
          return [...prevSelected, id];
        } else {
          return prevSelected.filter(q => q !== id);
        }
      });
    }
  };


  let totalPoints = 0;
  const calculatePoints = (pointType) => {
    switch (pointType) {
      case "point2":
        totalPoints += 2;
        break;
      case "point1":
        totalPoints += 1;
        break;
      case "point3":
        totalPoints += 3;
        break;
      default:
        break;
    }
    return totalPoints;
  };
  let totalPoints2 = 0;
  const calculatePoints2 = (pointType) => {
    switch (pointType) {
      case "point2":
        totalPoints2 += 2;
        break;
      case "point1":
        totalPoints2 += 1;
        break;
      case "point3":
        totalPoints2 += 3;
        break;
      default:
        break;
    }
    return totalPoints2;
  };

  function findJerseyNumber(t_id, r_id) {
    let team, roster;
    if (matchData?.event_team_a_id == t_id) {
      team = matchData?.team_a_rosters;
    } else if (matchData?.event_team_b_id == t_id) {
      team = matchData?.team_b_rosters;
    } else {
      return "";
    }
    roster = team.find(player => player?.roster_id == r_id);
    return roster ? roster.jersey_number : "";
  }

  function findPlayerName(t_id, r_id) {
    let team, roster;
    if (matchData?.event_team_a_id == t_id) {
      team = matchData?.team_a_rosters;
    } else if (matchData?.event_team_b_id == t_id) {
      team = matchData?.team_b_rosters;
    } else {
      return "";
    }
    roster = team.find(player => player.roster_id == r_id);
    return roster ? roster.short_name : "";
  }
  const handleDelScore = (data) => {
    setDeleteLoading(true)
    const headers = {
      'Authorization': token,
      'Content-Type': 'multipart/form-data',
    };
    axios.post(`${process.env.REACT_APP_API_ROOT}` + '/api/del_score/', data, { headers })
      .then(response => {
        if (response.status === 201) {

          dispatch(gameData(response.data.score));
          setScoreDeleteModal(false)
          setScoreId(null)
          setDeleteLoading(false)
          setUserActionSelect()
          setTeamOnePlayerSelect()
          setUserTwoActionSelect()
          setTeamTwoPlayerSelect()
          setSelectLog(null)
          setSelectLogTeamTwo(null)
          toast.success('Score deleted successfully')

          // Call stats APIs after successful score deletion
          callEventStats();
        }

      })
      .catch(error => {
        console.error('Error making POST request:', error);
      });
  };
  const handleMinutesChange = (amount) => {
    dispatch(setMinutesLog(minutes + amount));
  };

  const handleSecondsChange = (amount) => {
    let newSeconds = seconds + amount;
    if (newSeconds >= 60) {
      dispatch(setMinutesLog(minutes + 1));
      newSeconds -= 60;
    } else if (newSeconds < 0) {
      dispatch(setMinutesLog(minutes - 1));
      newSeconds += 60;
    }
    dispatch(setSecondsLog(newSeconds));
  };

  const handleQuarterChange = (e) => {
    const selectedQuarter = e;
    if (eventType == '5x5') {
      if (selectedQuarter == 'Overtime') {
        dispatch(setMinutesLog(eventType5x5OvertimeTimer));
        dispatch(setSecondsLog(0));
      } else {
        dispatch(setMinutesLog(eventType5x5DefaultTimer));
        dispatch(setSecondsLog(0));
      }

    } else if (eventType == '3x3') {

      if (selectedQuarter == 'Overtime') {
        dispatch(setMinutesLog(eventType3x3OvertimeTimer));
        dispatch(setSecondsLog(0));
      } else {
        dispatch(setMinutesLog(eventType3x3DefaultTimer));
        dispatch(setSecondsLog(0));
      }

    }


    dispatch(setQuarterLog(selectedQuarter));

  };
  const user_data = JSON.parse(window.localStorage.getItem("user_data"));
  const user_id = user_data?.id;
  const addNewScoreBulkMutation = useMutation((formData) =>
    axios.post(
      `${process.env.REACT_APP_API_ROOT}/api/add_new_score_bulk/`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `${token}`, // Include your authorization token here
        },
      }
    )
  );

  // Function to call event stats APIs after score is added
  const callEventStats = async () => {
    if (!event_id || !token) {
      console.error("Missing event_id or token for stats API calls");
      return;
    }

    try {
      // Call team stats API
      const teamStatsUrl = `${process.env.REACT_APP_API_ROOT}/api/event/v2/event_stats/?event_id=${event_id}&level=team&force_recalc=true`;
      const teamStatsPromise = axios.get(teamStatsUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      // Call roster stats API
      const rosterStatsUrl = `${process.env.REACT_APP_API_ROOT}/api/event/v2/event_stats/?event_id=${event_id}&level=roster&force_recalc=true`;
      const rosterStatsPromise = axios.get(rosterStatsUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      // Execute both API calls in parallel
      await Promise.all([teamStatsPromise, rosterStatsPromise]);

      console.log("Event stats recalculated successfully");
    } catch (error) {
      console.error("Error calling event stats APIs:", error);
    }
  };

  const handleAddNewScore = async (t_id, score_type, r_id) => {
    if (score_type && r_id && quarterLog) {
      setLoading(true);

      const data = [
        {
          score_type: score_type,
          loc_x: 0,
          loc_y: 0,
          score_timer: minutes * 60 + seconds,
          event_id: event_id,
          eg_id: event_group_id,
          r_id: r_id,
          t_id: t_id,
          sl_no: sl_no,
          score_period: quarterLog,
          star: false,
          scorer_id: user_id,
        }
      ];
      const formdata = new FormData();
      formdata.append("data", JSON.stringify([...data]));
      try {
        const response = await addNewScoreBulkMutation.mutateAsync(formdata);



        if (response) {

          dispatch(gameData(response.data.score));
          dispatch(updateSLNo());

          setUserActionSelect();
          setTeamOnePlayerSelect();
          setUserTwoActionSelect();
          setTeamTwoPlayerSelect();
          toast.success('Successfully added new score');

          // Call stats APIs after successful score addition
          callEventStats();

        }
      } catch (error) {
        console.error("Error adding new score:", error);
        toast.error('Failed to add new score');
      } finally {
        setLoading(false);
      }
    } else {
      toast.error('Please Select Score, Player, and Period');
    }
  };
  const [showError, setShowError] = useState(false); // To manage the Error component state

  useEffect(() => {
    const timer = setTimeout(() => {
      if (!matchData) {
        setShowError(true); // Show the Error component after 10 seconds if matchData is still not available
      }
    }, 10000); // 10000 milliseconds = 10 seconds

    return () => clearTimeout(timer); // Cleanup the timer when the component unmounts or when matchData is available
  }, [matchData]); // Only run this effect when matchData changes

  if (showError) {
    return <div className='absolute top-0 bottom-0 left-0 right-0'>
      <ErrorPage />
    </div>; // Show the Error component after 10 seconds
  }

  return (
    <>
      {
        matchData ? <div className='flex items-start gap-6 justify-center relative '>
          <div className='max-w-[696px] relative w-full min-h-screen border-r-[#E8E8E8] border-r-[1px] pt-6 '>
            <div className='flex items-center gap-2'>
              <div className='w-max flex cursor-pointer bg-[#F2F2F2] rounded h-10 gap-3 justify-start items-center px-[6px] py-2'>
                <input
                  type="checkbox"
                  id="selectAll"
                  className='max-w-6 w-full min-w-6 h-6'
                  onChange={handleCheckboxChange}
                  checked={isSelectAllChecked}
                />
                <label className='font-montserrat font-medium text-base flex-1 text-nowrap block' htmlFor="selectAll">Select All</label>
              </div>
              {
                filterQuarterOptions(quarterOptions)?.map((option, i) => (
                  <div key={i} className='cursor-pointer w-max flex bg-[#F2F2F2] rounded h-10 gap-3 justify-start items-center px-[6px] py-2'>
                    <input
                      type="checkbox"
                      className='max-w-6 w-full min-w-6 h-6'
                      id={option.value}
                      onChange={handleCheckboxChange}
                      checked={selectedQuarters?.includes(option.value)}
                    />
                    <label className='font-montserrat font-medium text-base flex-1 text-nowrap block' htmlFor={option.value}>{option.label}</label>
                  </div>
                ))
              }
              <div className='w-max flex cursor-pointer bg-[#F2F2F2] rounded h-10 gap-3 justify-start items-center px-[6px] py-2'>
                <input
                  type="checkbox"
                  id="foul"
                  className='max-w-6 w-full min-w-6 h-6'
                  onChange={handleCheckboxChange}
                  checked={selectedQuarters?.includes('foul')}
                />
                <label className='font-montserrat font-medium text-base flex-1 text-nowrap block' htmlFor="foul">Foul</label>
              </div>
            </div>
            <div className='max-w-[672px] w-full border-[1px] border-[#E8E8E8] relative z-20 mt-12 max-h-[57vh] overflow-y-auto eventActionLogsScrollBar'>
              <div className='w-full flex items-center sticky top-0 z-[3]'>
                <div className='max-w-[266px] w-full h-[64px] bg-light z-[3] border-[#E8E8E8] border-[1px] border-t-0 border-l-0 flex justify-center items-center font-bebas text-2xl ' style={{ color: teamOneColor }}>{teamOneName}</div>
                <div className='max-w-[140px] w-full h-[64px] bg-light z-[3] border-[#E8E8E8] border-[1px] border-t-0 border-x-0 flex justify-center items-center font-bebas text-2xl text-[#212325]'>Score</div>
                <div className='max-w-[266px] w-full h-[64px] bg-light z-[3] border-[#E8E8E8] border-[1px] border-t-0 border-r-0 flex justify-center items-center font-bebas text-2xl ' style={{ color: teamTwoColor }}>{teamTwoName}</div>
              </div>
              <div className='relative z-[1]'>
                {
                  filteredMatchData?.sort((a, b) => a.seq - b.seq)?.slice().reverse().map((scoreLog, i) => (
                    <div key={scoreLog.data_id} className={`flex`} >
                      <div className={`px-[20px] py-[34px]  max-w-[266px] w-full ${scoreLog.score_type && selectLog?.data_id === scoreLog?.data_id && event_team_a_id == scoreLog.t_id ? 'bg-[#F2F2F2]' : 'bg-transparent'}  border-[#E8E8E8] border-[1px] border-t-0 border-l-0 flex justify-center items-center `}>
                        {
                          event_team_a_id == scoreLog.t_id &&
                          <div
                            onClick={() => [handleSelectLogTeamOne({
                              type: scoreLog.type,
                              data_id: scoreLog.data_id,
                              eg_id: scoreLog.eg_id,
                              event_id: scoreLog.event_id,
                              r_id: scoreLog.r_id,
                            }),]}
                            className={`max-w-[225px]  p-3 w-full flex  flex-col relative items-start border-[1px] border-l-[4px] rounded-sm ${scoreLog.score_type && selectLog?.data_id === scoreLog?.data_id && event_team_a_id == scoreLog.t_id ? 'bg-[#ffff] cursor-pointer' : 'bg-transparent cursor-pointer'}`}
                            style={{ borderColor: teamOneColor }}
                          >
                            <p className={`font-bebas absolute right-1 top-0 text-right text-sm
                            `}
                              style={{
                                color: teamOneColor
                              }}
                            >
                              #{scoreLog?.data_id || scoreLog.id
                              }
                            </p>
                            <p className={`font-bebas  text-xl
                            `}
                              style={{
                                color: teamOneColor
                              }}
                            >
                              {scoreLog.score_type == 'point1' && '1pt made'}
                              {scoreLog.score_type == 'point2' && '2pt made'}
                              {scoreLog.score_type == 'point3' && '3pt made'}
                              {scoreLog.score_type == 'pointMiss1' && '1pt miss'}
                              {scoreLog.score_type == 'pointMiss2' && '2pt miss'}
                              {scoreLog.score_type == 'pointMiss3' && '3pt miss'}
                              {scoreLog.score_type == 'assist' && 'Assist'}
                              {scoreLog.score_type == 'offensiveRebound' && 'Offensive rebound'}
                              {scoreLog.score_type == 'defensiveRebound' && 'Defensive rebound'}
                              {scoreLog.score_type == 'block' && scoreLog.t_id == matchData.event_team_a_id && 'Block'}
                              {scoreLog.score_type == 'block' && scoreLog.t_id == matchData.event_team_b_id && 'Block'}
                              {scoreLog.score_type == 'steal' && 'Steal'}
                              {scoreLog.score_type == 'turnover' && 'Turnover'}
                              {scoreLog.score_type == 'personalFoul' && 'Personal Foul'}
                              {scoreLog.score_type == 'foulDrawn' && 'Foul Drawn'}
                              {scoreLog.score_type == 'technicalFoul' && 'Technical Foul'}
                            </p>
                            <p
                              className={`font-bebas  text-xl`}
                              style={{
                                color: scoreLog.t_id === matchData.event_team_a_id ? teamOneColor : teamTwoColor
                              }}
                            >
                              {!scoreLog.score_type && "Substitutions"}
                            </p>
                            {
                              !scoreLog.score_type &&
                              <div className='flex flex-col gap-2 w-full'>
                                <div className='flex gap-2 items-center '>
                                  <div className='max-w-[34px] font-montserrat uppercase text-light font-semibold text-[10px] w-full h-5 bg-[#63D799] rounded-sm flex justify-center items-center'>
                                    in
                                  </div>
                                  <p className='text-primary text-xs font-montserrat font-semibold'>&nbsp; | # {findJerseyNumber(scoreLog.t_id, scoreLog?.r_id_1_new)} |
                                    &nbsp; {findPlayerName(scoreLog.t_id, scoreLog?.r_id_1_new)}</p>
                                </div>
                                <div className='flex gap-2 items-center '>
                                  <div className='max-w-[34px] font-montserrat uppercase text-light font-semibold text-[10px] w-full h-5 bg-[#DB5F66] rounded-sm flex justify-center items-center'>
                                    out
                                  </div>
                                  <p className='text-primary text-xs font-montserrat font-semibold'>&nbsp; | # {findJerseyNumber(scoreLog.t_id, scoreLog?.r_id_1_org)} |
                                    &nbsp; {findPlayerName(scoreLog.t_id, scoreLog?.r_id_1_org)}</p>
                                </div>
                                {/* 2 */}
                                <div className='flex gap-2 items-center '>
                                  <div className='max-w-[34px] font-montserrat uppercase text-light font-semibold text-[10px] w-full h-5 bg-[#63D799] rounded-sm flex justify-center items-center'>
                                    in
                                  </div>
                                  <p className='text-primary text-xs font-montserrat font-semibold'>&nbsp; | # {findJerseyNumber(scoreLog.t_id, scoreLog?.r_id_2_new)} |
                                    &nbsp; {findPlayerName(scoreLog.t_id, scoreLog?.r_id_2_new)}</p>
                                </div>
                                <div className='flex gap-2 items-center '>
                                  <div className='max-w-[34px] font-montserrat uppercase text-light font-semibold text-[10px] w-full h-5 bg-[#DB5F66] rounded-sm flex justify-center items-center'>
                                    out
                                  </div>
                                  <p className='text-primary text-xs font-montserrat font-semibold'>&nbsp; | # {findJerseyNumber(scoreLog?.t_id, scoreLog?.r_id_2_org)} |
                                    &nbsp; {findPlayerName(scoreLog?.t_id, scoreLog?.r_id_2_org)}</p>
                                </div>
                                {/* 2 */}
                                {/* 3 */}
                                <div className='flex gap-2 items-center '>
                                  <div className='max-w-[34px] font-montserrat uppercase text-light font-semibold text-[10px] w-full h-5 bg-[#63D799] rounded-sm flex justify-center items-center'>
                                    in
                                  </div>
                                  <p className='text-primary text-xs font-montserrat font-semibold'>&nbsp; | # {findJerseyNumber(scoreLog?.t_id, scoreLog?.r_id_3_new)} |
                                    &nbsp; {findPlayerName(scoreLog?.t_id, scoreLog?.r_id_3_new)}</p>
                                </div>
                                <div className='flex gap-2 items-center '>
                                  <div className='max-w-[34px] font-montserrat uppercase text-light font-semibold text-[10px] w-full h-5 bg-[#DB5F66] rounded-sm flex justify-center items-center'>
                                    out
                                  </div>
                                  <p className='text-primary text-xs font-montserrat font-semibold'>&nbsp; | # {findJerseyNumber(scoreLog?.t_id, scoreLog?.r_id_3_org)} |
                                    &nbsp; {findPlayerName(scoreLog?.t_id, scoreLog?.r_id_3_org)}</p>
                                </div>
                                {/* 3 */}
                                {/* 4 */}
                                <div className='flex gap-2 items-center '>
                                  <div className='max-w-[34px] font-montserrat uppercase text-light font-semibold text-[10px] w-full h-5 bg-[#63D799] rounded-sm flex justify-center items-center'>
                                    in
                                  </div>
                                  <p className='text-primary text-xs font-montserrat font-semibold'>&nbsp; | # {findJerseyNumber(scoreLog?.t_id, scoreLog?.r_id_4_new)} |
                                    &nbsp; {findPlayerName(scoreLog?.t_id, scoreLog?.r_id_4_new)}</p>
                                </div>
                                <div className='flex gap-2 items-center '>
                                  <div className='max-w-[34px] font-montserrat uppercase text-light font-semibold text-[10px] w-full h-5 bg-[#DB5F66] rounded-sm flex justify-center items-center'>
                                    out
                                  </div>
                                  <p className='text-primary text-xs font-montserrat font-semibold'>&nbsp; | # {findJerseyNumber(scoreLog.t_id, scoreLog?.r_id_4_org)} |
                                    &nbsp; {findPlayerName(scoreLog.t_id, scoreLog?.r_id_4_org)}</p>
                                </div>
                                {/* 4 */}
                                {/* 5 */}
                                <div className='flex gap-2 items-center '>
                                  <div className='max-w-[34px] font-montserrat uppercase text-light font-semibold text-[10px] w-full h-5 bg-[#63D799] rounded-sm flex justify-center items-center'>
                                    in
                                  </div>
                                  <p className='text-primary text-xs font-montserrat font-semibold'>&nbsp; | # {findJerseyNumber(scoreLog.t_id, scoreLog?.r_id_5_new)} |
                                    &nbsp; {findPlayerName(scoreLog.t_id, scoreLog?.r_id_5_new)}</p>
                                </div>
                                <div className='flex gap-2 items-center '>
                                  <div className='max-w-[34px] font-montserrat uppercase text-light font-semibold text-[10px] w-full h-5 bg-[#DB5F66] rounded-sm flex justify-center items-center'>
                                    out
                                  </div>
                                  <p className='text-primary text-xs font-montserrat font-semibold'>&nbsp; | # {findJerseyNumber(scoreLog.t_id, scoreLog?.r_id_5_org)} |
                                    &nbsp; {findPlayerName(scoreLog.t_id, scoreLog?.r_id_5_org)}</p>
                                </div>
                                {/* 5 */}
                              </div>
                            }
                            {
                              scoreLog.score_type &&

                              <p className='text-primary text-xs font-montserrat font-semibold'>
                                {teamOneName}
                                &nbsp; | # {findJerseyNumber(scoreLog.t_id, scoreLog.r_id)} |
                                &nbsp; {findPlayerName(scoreLog.t_id, scoreLog.r_id)}
                              </p>
                            }
                            <div className='flex gap-2 w-10 items-center justify-end absolute right-1 ]'>
                              {
                                scoreLog?.star && <div>
                                  <IconCollection customClass='md:max-w-4 max-w-[8px] w-full md:h-4 h-[8px]' name="star-color-icon" />
                                </div>
                              }
                              {
                                scoreLog.type && <button
                                  onClick={() => [setScoreDeleteModal(true), setScoreId({
                                    type: scoreLog.type,
                                    data_id: scoreLog.data_id,
                                    eg_id: scoreLog.eg_id,
                                    event_id: scoreLog.event_id
                                  })]}
                                >
                                  <IconCollection customClass='md:max-w-4 max-w-[8px] w-full md:h-4 h-[8px]' name="delete-icon" />
                                </button>
                              }

                            </div>
                          </div>
                        }
                      </div>
                      <div className='px-[27px] py-[16px] max-w-[140px] w-full   border-[#E8E8E8] border-[1px] border-t-0 border-x-0 flex justify-center items-center '>
                        <div className='max-w-[85px] w-full h-[108] border-[1px] border-[#E8E8E8] rounded flex flex-col justify-center items-center py-3'>
                          <p className='font-bebas text-xl text-[#4A4A4A]'>{scoreLog?.score_period}</p>
                          <p className='font-bebas text-[26px] text-[#1A1A1A]'>
                            {calculatePoints(scoreLog.t_id === event_team_a_id && scoreLog.score_type)} - {calculatePoints2(scoreLog.t_id === event_team_b_id && scoreLog.score_type)}
                          </p>
                          <p className='font-montserrat text-sm text-[#4A4A4A]'>{formatTimeFromSeconds(scoreLog?.score_timer)}</p>
                        </div>
                      </div>
                      <div className={`px-[20px] py-[34px] max-w-[266px] w-full  border-[#E8E8E8] border-[1px] border-t-0 border-r-0 flex justify-center items-center ${scoreLog.score_type && selectLogTeamTwo?.data_id === scoreLog?.data_id && event_team_b_id == scoreLog.t_id ? 'bg-[#F2F2F2]' : 'bg-transparent'}`}>
                        {
                          event_team_b_id == scoreLog?.t_id &&
                          <div
                            onClick={() => [handleSelectLogTeamTwo({
                              type: scoreLog.type,
                              data_id: scoreLog.data_id,
                              eg_id: scoreLog.eg_id,
                              event_id: scoreLog.event_id,
                              r_id: scoreLog.r_id,
                            }), setTeam('team2'), setUserActionSelect(), setTeamOnePlayerSelect()]}
                            className={`max-w-[225px]   p-3 w-full border-[#ce9136] flex-col flex relative items-start border-[1px] border-l-[4px] rounded-sm ${scoreLog.score_type && selectLogTeamTwo?.data_id === scoreLog?.data_id && event_team_b_id == scoreLog.t_id ? 'bg-[#ffff] cursor-pointer' : 'bg-transparent cursor-pointer'}`}
                            style={{ borderColor: teamTwoColor }}
                          >
                            <p className={`font-bebas absolute right-1 top-0 text-right text-sm`}
                              style={{ color: teamTwoColor }}
                            >#{scoreLog?.data_id || scoreLog.id}</p>
                            <p className={`font-bebas  text-xl`}
                              style={{
                                color: teamTwoColor
                              }}
                            >
                              {scoreLog.score_type == 'point1' && '1pt made'}
                              {scoreLog.score_type == 'point2' && '2pt made'}
                              {scoreLog.score_type == 'point3' && '3pt made'}
                              {scoreLog.score_type == 'pointMiss1' && '1pt miss'}
                              {scoreLog.score_type == 'pointMiss2' && '2pt miss'}
                              {scoreLog.score_type == 'pointMiss3' && '3pt miss'}
                              {scoreLog.score_type == 'assist' && 'Assist'}
                              {scoreLog.score_type == 'offensiveRebound' && 'Offensive rebound'}
                              {scoreLog.score_type == 'defensiveRebound' && 'Defensive rebound'}
                              {scoreLog.score_type == 'block' && scoreLog.t_id == matchData.event_team_a_id && 'Block'}
                              {scoreLog.score_type == 'block' && scoreLog.t_id == matchData.event_team_b_id && 'Block'}
                              {scoreLog.score_type == 'steal' && 'Steal'}
                              {scoreLog.score_type == 'turnover' && 'Turnover'}
                              {scoreLog.score_type == 'personalFoul' && 'Personal Foul'}
                              {scoreLog.score_type == 'foulDrawn' && 'Foul Drawn'}
                              {scoreLog.score_type == 'technicalFoul' && 'Technical Foul'}
                            </p>
                            <p
                              className={`font-bebas  text-xl`}
                              style={{
                                color: scoreLog.t_id === matchData.event_team_a_id ? teamOneColor : teamTwoColor
                              }}
                            >
                              {!scoreLog.score_type && "Substitutions"}
                            </p>
                            {
                              !scoreLog.score_type &&
                              <div className='flex flex-col gap-2 w-full'>
                                <div className='flex gap-2 items-center '>
                                  <div className='max-w-[34px] font-montserrat uppercase text-light font-semibold text-[10px] w-full h-5 bg-[#63D799] rounded-sm flex justify-center items-center'>
                                    in
                                  </div>
                                  <p className='text-primary text-xs font-montserrat font-semibold'>&nbsp; | # {findJerseyNumber(scoreLog.t_id, scoreLog?.r_id_1_new)} |
                                    &nbsp; {findPlayerName(scoreLog.t_id, scoreLog?.r_id_1_new)}</p>
                                </div>
                                <div className='flex gap-2 items-center '>
                                  <div className='max-w-[34px] font-montserrat uppercase text-light font-semibold text-[10px] w-full h-5 bg-[#DB5F66] rounded-sm flex justify-center items-center'>
                                    out
                                  </div>
                                  <p className='text-primary text-xs font-montserrat font-semibold'>&nbsp; | # {findJerseyNumber(scoreLog.t_id, scoreLog?.r_id_1_org)} |
                                    &nbsp; {findPlayerName(scoreLog.t_id, scoreLog?.r_id_1_org)}</p>
                                </div>
                                {/* 2 */}
                                <div className='flex gap-2 items-center '>
                                  <div className='max-w-[34px] font-montserrat uppercase text-light font-semibold text-[10px] w-full h-5 bg-[#63D799] rounded-sm flex justify-center items-center'>
                                    in
                                  </div>
                                  <p className='text-primary text-xs font-montserrat font-semibold'>&nbsp; | # {findJerseyNumber(scoreLog.t_id, scoreLog?.r_id_2_new)} |
                                    &nbsp; {findPlayerName(scoreLog.t_id, scoreLog?.r_id_2_new)}</p>
                                </div>
                                <div className='flex gap-2 items-center '>
                                  <div className='max-w-[34px] font-montserrat uppercase text-light font-semibold text-[10px] w-full h-5 bg-[#DB5F66] rounded-sm flex justify-center items-center'>
                                    out
                                  </div>
                                  <p className='text-primary text-xs font-montserrat font-semibold'>&nbsp; | # {findJerseyNumber(scoreLog?.t_id, scoreLog?.r_id_2_org)} |
                                    &nbsp; {findPlayerName(scoreLog?.t_id, scoreLog?.r_id_2_org)}</p>
                                </div>
                                {/* 2 */}
                                {/* 3 */}
                                <div className='flex gap-2 items-center '>
                                  <div className='max-w-[34px] font-montserrat uppercase text-light font-semibold text-[10px] w-full h-5 bg-[#63D799] rounded-sm flex justify-center items-center'>
                                    in
                                  </div>
                                  <p className='text-primary text-xs font-montserrat font-semibold'>&nbsp; | # {findJerseyNumber(scoreLog?.t_id, scoreLog?.r_id_3_new)} |
                                    &nbsp; {findPlayerName(scoreLog?.t_id, scoreLog?.r_id_3_new)}</p>
                                </div>
                                <div className='flex gap-2 items-center '>
                                  <div className='max-w-[34px] font-montserrat uppercase text-light font-semibold text-[10px] w-full h-5 bg-[#DB5F66] rounded-sm flex justify-center items-center'>
                                    out
                                  </div>
                                  <p className='text-primary text-xs font-montserrat font-semibold'>&nbsp; | # {findJerseyNumber(scoreLog?.t_id, scoreLog?.r_id_3_org)} |
                                    &nbsp; {findPlayerName(scoreLog?.t_id, scoreLog?.r_id_3_org)}</p>
                                </div>
                                {/* 3 */}
                                {/* 4 */}
                                <div className='flex gap-2 items-center '>
                                  <div className='max-w-[34px] font-montserrat uppercase text-light font-semibold text-[10px] w-full h-5 bg-[#63D799] rounded-sm flex justify-center items-center'>
                                    in
                                  </div>
                                  <p className='text-primary text-xs font-montserrat font-semibold'>&nbsp; | # {findJerseyNumber(scoreLog?.t_id, scoreLog?.r_id_4_new)} |
                                    &nbsp; {findPlayerName(scoreLog?.t_id, scoreLog?.r_id_4_new)}</p>
                                </div>
                                <div className='flex gap-2 items-center '>
                                  <div className='max-w-[34px] font-montserrat uppercase text-light font-semibold text-[10px] w-full h-5 bg-[#DB5F66] rounded-sm flex justify-center items-center'>
                                    out
                                  </div>
                                  <p className='text-primary text-xs font-montserrat font-semibold'>&nbsp; | # {findJerseyNumber(scoreLog.t_id, scoreLog?.r_id_4_org)} |
                                    &nbsp; {findPlayerName(scoreLog.t_id, scoreLog?.r_id_4_org)}</p>
                                </div>
                                {/* 4 */}
                                {/* 5 */}
                                <div className='flex gap-2 items-center '>
                                  <div className='max-w-[34px] font-montserrat uppercase text-light font-semibold text-[10px] w-full h-5 bg-[#63D799] rounded-sm flex justify-center items-center'>
                                    in
                                  </div>
                                  <p className='text-primary text-xs font-montserrat font-semibold'>&nbsp; | # {findJerseyNumber(scoreLog.t_id, scoreLog?.r_id_5_new)} |
                                    &nbsp; {findPlayerName(scoreLog.t_id, scoreLog?.r_id_5_new)}</p>
                                </div>
                                <div className='flex gap-2 items-center '>
                                  <div className='max-w-[34px] font-montserrat uppercase text-light font-semibold text-[10px] w-full h-5 bg-[#DB5F66] rounded-sm flex justify-center items-center'>
                                    out
                                  </div>
                                  <p className='text-primary text-xs font-montserrat font-semibold'>&nbsp; | # {findJerseyNumber(scoreLog.t_id, scoreLog?.r_id_5_org)} |
                                    &nbsp; {findPlayerName(scoreLog.t_id, scoreLog?.r_id_5_org)}</p>
                                </div>
                                {/* 5 */}
                              </div>
                            }
                            {
                              scoreLog.score_type && <p className='text-primary text-xs font-montserrat font-semibold'>
                                {teamTwoName}
                                &nbsp; | # {findJerseyNumber(scoreLog.t_id, scoreLog.r_id)} |
                                &nbsp; {findPlayerName(scoreLog.t_id, scoreLog.r_id)}
                              </p>
                            }
                            <div className='flex gap-2 w-10 items-center justify-end absolute right-1'>
                              {
                                scoreLog?.star && <div>
                                  <IconCollection customClass='md:max-w-4 max-w-[8px] w-full md:h-4 h-[8px]' name="star-color-icon" />
                                </div>
                              }
                              {
                                scoreLog.type && <button
                                  onClick={() => [setScoreDeleteModal(true), setScoreId({
                                    type: scoreLog.type,
                                    data_id: scoreLog.data_id,
                                    eg_id: scoreLog.eg_id,
                                    event_id: scoreLog.event_id
                                  })]}
                                >
                                  <IconCollection customClass='md:max-w-4 max-w-[8px] w-full md:h-4 h-[8px]' name="delete-icon" />
                                </button>
                              }
                            </div>
                          </div>
                        }
                      </div>

                    </div>
                  ))
                }
              </div>
            </div>
            {
              scoreDeleteModal &&
              <div className='w-full  justify-center items-center absolute z-[22] top-0 right-0 left-0 bottom-0 flex'>
                <div className='max-w-[300px] w-full bg-[#F2F2F2]  rounded  p-5'>

                  <p className='font-bebas text-xl text-center text-black'>{deleteLoading ? "deleting" : "deleting a score is irreversible"}</p>
                  {
                    !deleteLoading && <div className='flex justify-center items-center gap-10 mt-10'>
                      <button className='max-w-[48px] rounded h-[30px] w-full bg-black   font-bebas text-lg text-white ' onClick={() => setScoreDeleteModal(false)}>No</button>
                      <button className='max-w-[48px] rounded h-[30px] w-full bg-primary font-bebas text-lg text-white'
                        onClick={() => handleDelScore(scoreId)}
                      >Yes</button>
                    </div>
                  }

                </div>
              </div>
            }
            <button
              onClick={() => [setSelectLog(), setSelectLogTeamTwo()]}
              className='my-5 max-w-[108px] w-full font-bebas text-2xl h-[48px] bg-[#A46E40] text-white rounded flex justify-center items-center'>
              Add log
            </button>
          </div>
          <div className='max-w-[696px] w-full min-h-screen pt-6'>
            <p className='font-bebas text-2xl text-left pb-10'>Log {selectLog?.data_id || selectLogTeamTwo?.data_id}</p>
            <div className='w-full flex justify-between items-center border-b-[1px] border-[#E8E8E8] pb-4'>
              <div className='max-w-[120px] text-[#4A4A4A] w-full font-bebas text-xl'>
                Which team
              </div>
              <div className='flex flex-1 items-center justify-evenly'>
                <div onClick={() => [setTeam('team1'), setUserTwoActionSelect(), setTeamTwoPlayerSelect()]} className={`text-2xl cursor-pointer font-bebas ${team == 'team1' ? 'text-[#B48658]' : 'text-black'}`}>{teamOneName}</div>
                <div onClick={() => [setTeam('team2'), setUserActionSelect(), setTeamOnePlayerSelect()]} className={`text-2xl cursor-pointer font-bebas ${team == 'team2' ? 'text-[#B48658]' : 'text-black'}`}>{teamTwoName}</div>
              </div>
            </div>
            {
              team == 'team1' && <>
                {
                  !selectLog && <div className='w-full flex justify-between items-start pb-4 mt-10'>
                    <div className='max-w-[120px] text-[#4A4A4A] w-full font-bebas text-xl'>
                      What actions
                    </div>
                    <div className='flex flex-1 flex-wrap gap-3'>
                      <button
                        onClick={() => handleButtonClick('point2')}
                        className={`max-w-[184px] h-16 w-full ${userActionSelect?.includes('point2') ? 'bg-red-500 text-white' : 'bg-[#F2F2F2] text-[#419066]'
                          } rounded flex justify-center items-center font-bebas text-2xl `}>
                        2pt made
                      </button>
                      <button
                        onClick={() => handleButtonClick('point3')}
                        className={`max-w-[184px] h-16 w-full ${userActionSelect?.includes('point3') ? 'bg-red-500 text-white' : 'bg-[#F2F2F2] text-[#419066]'
                          } rounded flex justify-center items-center font-bebas text-2xl text-[#419066]`}>
                        3pt made
                      </button>
                      <button
                        onClick={() => handleButtonClick('point1')}
                        className={`max-w-[184px] h-16 w-full ${userActionSelect?.includes('point1') ? 'bg-red-500 text-white' : 'bg-[#F2F2F2] text-[#419066]'
                          } rounded flex justify-center items-center font-bebas text-2xl text-[#419066]`}>
                        1pt made
                      </button>
                      <button
                        onClick={() => handleButtonClick('pointMiss2')}
                        className={`max-w-[184px] h-16 w-full ${userActionSelect?.includes('pointMiss2') ? 'bg-red-500 text-white' : 'bg-[#F2F2F2] text-[#D54043]'
                          } rounded flex justify-center items-center font-bebas text-2xl `}>
                        2pt miss
                      </button>
                      <button
                        onClick={() => handleButtonClick('pointMiss3')}
                        className={`max-w-[184px] h-16 w-full ${userActionSelect?.includes('pointMiss3') ? 'bg-red-500 text-white' : 'bg-[#F2F2F2] text-[#D54043]'
                          } rounded flex justify-center items-center font-bebas text-2xl `}>
                        3pt miss
                      </button>
                      <button
                        onClick={() => handleButtonClick('pointMiss1')}
                        className={`max-w-[184px] h-16 w-full ${userActionSelect?.includes('pointMiss1') ? 'bg-red-500 text-white' : 'bg-[#F2F2F2] text-[#D54043]'
                          } rounded flex justify-center items-center font-bebas text-2xl `}>
                        1pt miss
                      </button>
                      <button
                        onClick={() => handleButtonClick('assist')}
                        className={`max-w-[184px] h-16 w-full ${userActionSelect?.includes('assist') ? 'bg-red-500 text-white' : 'bg-[#F2F2F2] text-[#1A1A1A]'
                          } rounded flex justify-center items-center font-bebas text-2xl `}>
                        Assist
                      </button>
                      <button onClick={() => handleButtonClick('defensiveRebound')}
                        className={`max-w-[184px] h-16 w-full ${userActionSelect?.includes('defensiveRebound') ? 'bg-red-500 text-white' : 'bg-[#F2F2F2] text-[#1A1A1A]'
                          } rounded flex justify-center items-center font-bebas text-2xl `}>
                        Def rebound
                      </button>
                      <button onClick={() => handleButtonClick('offensiveRebound')}
                        className={`max-w-[184px] h-16 w-full ${userActionSelect?.includes('offensiveRebound') ? 'bg-red-500 text-white' : 'bg-[#F2F2F2] text-[#1A1A1A]'
                          } rounded flex justify-center items-center font-bebas text-2xl `}>
                        Off rebound
                      </button>
                      <button onClick={() => handleButtonClick('steal')}
                        className={`max-w-[184px] h-16 w-full ${userActionSelect?.includes('steal') ? 'bg-red-500 text-white' : 'bg-[#F2F2F2] text-[#1A1A1A]'
                          } rounded flex justify-center items-center font-bebas text-2xl `}>
                        Steal
                      </button>
                      <button
                        onClick={() => handleButtonClick('block')}
                        className={`max-w-[184px] h-16 w-full ${userActionSelect?.includes('block') ? 'bg-red-500 text-white' : 'bg-[#F2F2F2] text-[#1A1A1A]'
                          } rounded flex justify-center items-center font-bebas text-2xl `}>
                        Block
                      </button>
                      <button onClick={() => handleButtonClick('turnover')}
                        className={`max-w-[184px] h-16 w-full ${userActionSelect?.includes('turnover') ? 'bg-red-500 text-white' : 'bg-[#F2F2F2] text-[#1A1A1A]'
                          } rounded flex justify-center items-center font-bebas text-2xl `}>
                        Turnover
                      </button>
                      <button onClick={() => handleButtonClick('personalFoul')}
                        className={`max-w-[184px] h-16 w-full ${userActionSelect?.includes('personalFoul') ? 'bg-red-500 text-white' : 'bg-[#F2F2F2] text-[#1A1A1A]'
                          } rounded flex justify-center items-center font-bebas text-2xl `}>
                        Personal Foul
                      </button>
                      <button onClick={() => handleButtonClick('technicalFoul')}
                        className={`max-w-[184px] h-16 w-full ${userActionSelect?.includes('technicalFoul') ? 'bg-red-500 text-white' : 'bg-[#F2F2F2] text-[#1A1A1A]'
                          } rounded flex justify-center items-center font-bebas text-2xl `}>
                        Technical Foul
                      </button>
                      <button onClick={() => handleButtonClick('foulDrawn')}
                        className={`max-w-[184px] h-16 w-full ${userActionSelect?.includes('foulDrawn') ? 'bg-red-500 text-white' : 'bg-[#F2F2F2] text-[#1A1A1A]'
                          } rounded flex justify-center items-center font-bebas text-2xl `}>
                        Foul Drawn
                      </button>

                    </div>
                  </div>
                }
                <div className='w-full flex justify-between items-start pb-4 mt-10'>
                  <div className='max-w-[120px] text-[#4A4A4A] w-full font-bebas text-xl'>
                    Which player
                  </div>
                  <div className='flex flex-1 flex-wrap gap-x-3 gap-y-5'>
                    {
                      matchData?.team_a_rosters?.filter((player) => player.is_present).map((player, i) => (
                        <button
                          onClick={() => handleTeamOnePlayerSelect(player.roster_id)}
                          key={i} className={`max-w-[54px] h-[60px] w-full bg-transparent rounded  relative flex justify-center items-center font-bebas text-2xl  ${teamOnePlayerSelect === player.roster_id ? 'text-black ' : ' text-[#ffff]'}`}>
                          <IconCollection name="player-jersey-white-mini" svgFillColor={(teamOnePlayerSelect == player.roster_id) || (player.roster_id == selectLog?.r_id) ? '#f2f2f2' : teamOneColor} />
                          <p className=' text-[32px] text-center absolute left-0 right-0'>{player?.jersey_number}</p>
                        </button>
                      ))
                    }
                  </div>
                </div>
                {
                  !selectLog && <div className='w-full flex justify-between items-start pb-4 mt-10'>
                    <div className='max-w-[120px] text-[#4A4A4A] w-full font-bebas text-xl'>
                      Time
                    </div>
                    <div className='flex flex-1 flex-wrap gap-x-3 gap-y-5'>
                      <LogTimer />
                      <CustomDropdown
                        customStyle={`custom-drop-shadow text-[#4A4A4A] font-bebas text-[10px] md:text-lg md:max-w-[125px] max-w-[58px] p-[4.5px] md:p-3 h-[30px] md:h-14 rounded rounded cursor-pointer w-full flex justify-between items-center `}
                        customStyleDropdownList={`font-montserrat font-medium absolute bg-white rounded-md shadow-md w-full mt-3 p-1 md:p-4 flex flex-col justify-center items-center `}
                        liCustomStyle={`cursor-pointer py-1 md:py-2 text-[#4A4A4A] font-bebas text-[8px] md:text-xl hover:font-semibold w-full`}
                        dropdownContainer="md:max-w-[125px] max-w-[58px] w-full"
                        className=""
                        options={filterQuarterOptions(quarterOptions)}
                        defaultValue={quarterLog}
                        onChange={handleQuarterChange}
                      />
                    </div>
                  </div>
                }
                <div className='pt-3 border-t-[1px] my-10 border-[#E8E8E8] flex justify-between items-center'>
                  <div className='flex items-center gap-2 max-w-[240px] w-full'>
                    <button onClick={() => setScoreDeleteModal(true)} disabled={!selectLog?.data_id || loading} className='max-w-[108px] w-full font-bebas text-2xl h-[48px] bg-[#E8E8E8] text-[#4A4A4A] rounded flex justify-center items-center'>Delete</button>
                    {
                      selectLog &&
                      <button onClick={() => [setSelectLog(null), setTeamOnePlayerSelect()]} disabled={!selectLog?.data_id} className='max-w-[108px] w-full font-bebas text-2xl h-[48px] bg-[#E8E8E8] text-[#4A4A4A] rounded flex justify-center items-center'>Cancel</button>
                    }
                  </div>
                  {
                    !selectLog && <button disabled={loading} className='max-w-[108px] w-full font-bebas text-2xl h-[48px] bg-[#A46E40] text-white rounded flex justify-center items-center'
                      onClick={() => handleAddNewScore(event_team_a_id, userActionSelect, teamOnePlayerSelect)}
                    >{loading ? "Saving" : 'Save'}</button>
                  }
                  {
                    selectLog &&
                    <button disabled={loading} className='max-w-[108px] w-full font-bebas text-2xl h-[48px] bg-[#A46E40] text-white rounded flex justify-center items-center'
                      onClick={() => handleActionEditPlayer(event_id, teamOnePlayerSelect, selectLog.data_id)}
                    >{loading ? "Saving" : 'Save'}</button>
                  }
                </div>
              </>
            }
            {
              team == 'team2' && <>
                {
                  !selectLogTeamTwo &&
                  <div className='w-full flex justify-between items-start pb-4 mt-10'>
                    <div className='max-w-[120px] text-[#4A4A4A] w-full font-bebas text-xl'>
                      What actions
                    </div>
                    <div className='flex flex-1 flex-wrap gap-3'>
                      <button
                        onClick={() => handleButtonClickTwo('point2')}
                        className={`max-w-[184px] h-16 w-full ${userTwoActionSelect?.includes('point2') ? 'bg-red-500 text-white' : 'bg-[#F2F2F2] text-[#419066]'
                          } rounded flex justify-center items-center font-bebas text-2xl `}>
                        2pt made
                      </button>
                      <button
                        onClick={() => handleButtonClickTwo('point3')}
                        className={`max-w-[184px] h-16 w-full ${userTwoActionSelect?.includes('point3') ? 'bg-red-500 text-white' : 'bg-[#F2F2F2] text-[#419066]'
                          } rounded flex justify-center items-center font-bebas text-2xl text-[#419066]`}>
                        3pt made
                      </button>
                      <button
                        onClick={() => handleButtonClickTwo('point1')}
                        className={`max-w-[184px] h-16 w-full ${userTwoActionSelect?.includes('point1') ? 'bg-red-500 text-white' : 'bg-[#F2F2F2] text-[#419066]'
                          } rounded flex justify-center items-center font-bebas text-2xl text-[#419066]`}>
                        1pt made
                      </button>
                      <button
                        onClick={() => handleButtonClickTwo('pointMiss2')}
                        className={`max-w-[184px] h-16 w-full ${userTwoActionSelect?.includes('pointMiss2') ? 'bg-red-500 text-white' : 'bg-[#F2F2F2] text-[#D54043]'
                          } rounded flex justify-center items-center font-bebas text-2xl `}>
                        2pt miss
                      </button>
                      <button
                        onClick={() => handleButtonClickTwo('pointMiss3')}
                        className={`max-w-[184px] h-16 w-full ${userTwoActionSelect?.includes('pointMiss3') ? 'bg-red-500 text-white' : 'bg-[#F2F2F2] text-[#D54043]'
                          } rounded flex justify-center items-center font-bebas text-2xl `}>
                        3pt miss
                      </button>
                      <button
                        onClick={() => handleButtonClickTwo('pointMiss1')}
                        className={`max-w-[184px] h-16 w-full ${userTwoActionSelect?.includes('pointMiss1') ? 'bg-red-500 text-white' : 'bg-[#F2F2F2] text-[#D54043]'
                          } rounded flex justify-center items-center font-bebas text-2xl `}>
                        1pt miss
                      </button>
                      <button
                        onClick={() => handleButtonClickTwo('assist')}
                        className={`max-w-[184px] h-16 w-full ${userTwoActionSelect?.includes('assist') ? 'bg-red-500 text-white' : 'bg-[#F2F2F2] text-[#1A1A1A]'
                          } rounded flex justify-center items-center font-bebas text-2xl `}>
                        Assist
                      </button>
                      <button
                        onClick={() => handleButtonClickTwo('defensiveRebound')}
                        className={`max-w-[184px] h-16 w-full ${userTwoActionSelect?.includes('defensiveRebound') ? 'bg-red-500 text-white' : 'bg-[#F2F2F2] text-[#1A1A1A]'
                          } rounded flex justify-center items-center font-bebas text-2xl `}>
                        Def rebound
                      </button>
                      <button
                        onClick={() => handleButtonClickTwo('offensiveRebound')}
                        className={`max-w-[184px] h-16 w-full ${userTwoActionSelect?.includes('offensiveRebound') ? 'bg-red-500 text-white' : 'bg-[#F2F2F2] text-[#1A1A1A]'
                          } rounded flex justify-center items-center font-bebas text-2xl `}>
                        Off rebound
                      </button>
                      <button
                        onClick={() => handleButtonClickTwo('steal')}
                        className={`max-w-[184px] h-16 w-full ${userTwoActionSelect?.includes('steal') ? 'bg-red-500 text-white' : 'bg-[#F2F2F2] text-[#1A1A1A]'
                          } rounded flex justify-center items-center font-bebas text-2xl `}>
                        Steal
                      </button>
                      <button
                        onClick={() => handleButtonClickTwo('block')}
                        className={`max-w-[184px] h-16 w-full ${userTwoActionSelect?.includes('block') ? 'bg-red-500 text-white' : 'bg-[#F2F2F2] text-[#1A1A1A]'
                          } rounded flex justify-center items-center font-bebas text-2xl `}>
                        Block
                      </button>
                      <button
                        onClick={() => handleButtonClickTwo('turnover')}
                        className={`max-w-[184px] h-16 w-full ${userTwoActionSelect?.includes('turnover') ? 'bg-red-500 text-white' : 'bg-[#F2F2F2] text-[#419066]'
                          } rounded flex justify-center items-center font-bebas text-2xl text-[#1A1A1A]`}>
                        Turnover
                      </button>
                      <button
                        onClick={() => handleButtonClickTwo('personalFoul')}
                        className={`max-w-[184px] h-16 w-full ${userTwoActionSelect?.includes('personalFoul') ? 'bg-red-500 text-white' : 'bg-[#F2F2F2] text-black'
                          } rounded flex justify-center items-center font-bebas text-2xl text-[#1A1A1A]`}>
                        Personal Foul
                      </button>
                      <button
                        onClick={() => handleButtonClickTwo('technicalFoul')}
                        className={`max-w-[184px] h-16 w-full ${userTwoActionSelect?.includes('technicalFoul') ? 'bg-red-500 text-white' : 'bg-[#F2F2F2] text-black'
                          } rounded flex justify-center items-center font-bebas text-2xl text-[#1A1A1A]`}>
                        Technical Foul
                      </button>
                      <button
                        onClick={() => handleButtonClickTwo('foulDrawn')}
                        className={`max-w-[184px] h-16 w-full ${userTwoActionSelect?.includes('foulDrawn') ? 'bg-red-500 text-white' : 'bg-[#F2F2F2] text-black'
                          } rounded flex justify-center items-center font-bebas text-2xl text-[#1A1A1A]`}>
                        Foul Drawn
                      </button>

                    </div>
                  </div>
                }
                <div className='w-full flex justify-between items-start pb-4 mt-10'>
                  <div className='max-w-[120px] text-[#4A4A4A] w-full font-bebas text-xl'>
                    Which player
                  </div>
                  <div className='flex flex-1 flex-wrap gap-x-3 gap-y-5'>
                    {
                      matchData?.team_b_rosters?.filter((player) => player.is_present).map((player, i) => (
                        <button
                          onClick={() => handleTeamTwoPlayerSelect(player.roster_id)}
                          key={i} className={`max-w-[54px] h-[60px] w-full bg-transparent rounded  relative flex justify-center items-center font-bebas text-2xl ${teamTwoPlayerSelect == player.roster_id ? 'text-black' : ' text-[#ffff]'}`}>

                          <IconCollection name="player-jersey-white-mini" svgFillColor={(teamTwoPlayerSelect == player.roster_id) || (player.roster_id == selectLogTeamTwo?.r_id) ? '#f2f2f2' : teamTwoColor} />
                          <p className=' text-[32px] text-center absolute left-0 right-0'>{player?.jersey_number}</p>
                        </button>
                      ))
                    }
                  </div>
                </div>
                {
                  !selectLogTeamTwo &&
                  <div className='w-full flex justify-between items-start pb-4 mt-10'>
                    <div className='max-w-[120px] text-[#4A4A4A] w-full font-bebas text-xl'>
                      Time
                    </div>
                    <div className='flex flex-1 flex-wrap gap-x-3 gap-y-5'>
                      <div className='max-w-[190px] w-full flex gap-2'>
                        <div className='flex flex-col justify-between'>
                          <button onClick={() => handleMinutesChange(Number(1))} className='flex justify-center items-center w-6 h-6 border-[#CCCCCC] border-[1px] rounded bg-[#f2f2f2]'>
                            <IconCollection name="plus-icon-16" />
                          </button>
                          <button onClick={() => handleMinutesChange(Number(-1))} className='flex justify-center items-center w-6 h-6 border-[#CCCCCC] border-[1px] rounded bg-[#f2f2f2]'>
                            <IconCollection name="mains-icon-16" />
                          </button>
                        </div>
                        <div className='text-[64px] font-bebas text-[#1A1A1A]'>{minutes}:{seconds < 10 ? `0${seconds}` : seconds}</div>
                        <div className='flex flex-col justify-between'>
                          <button
                            onClick={() => handleSecondsChange(Number(1))}
                            className='flex justify-center items-center w-6 h-6 border-[#CCCCCC] border-[1px] rounded bg-[#f2f2f2]'>
                            <IconCollection name="plus-icon-16" />
                          </button>
                          <button onClick={() => handleSecondsChange(Number(-1))} className='flex justify-center items-center w-6 h-6 border-[#CCCCCC] border-[1px] rounded bg-[#f2f2f2]'>
                            <IconCollection name="mains-icon-16" />
                          </button>
                        </div>
                      </div>
                      <CustomDropdown
                        customStyle={`custom-drop-shadow text-[#4A4A4A] font-bebas text-[10px] md:text-lg md:max-w-[125px] max-w-[58px] p-[4.5px] md:p-3 h-[30px] md:h-14 rounded rounded cursor-pointer w-full flex justify-between items-center `}
                        customStyleDropdownList={`font-montserrat font-medium absolute bg-white rounded-md shadow-md w-full mt-3 p-1 md:p-4 flex flex-col justify-center items-center `}
                        liCustomStyle={`cursor-pointer py-1 md:py-2 text-[#4A4A4A] font-bebas text-[8px] md:text-xl hover:font-semibold w-full`}
                        dropdownContainer="md:max-w-[125px] max-w-[58px] w-full"
                        className=""
                        options={filterQuarterOptions(quarterOptions)}
                        defaultValue={quarterLog}
                        onChange={handleQuarterChange}
                      />
                    </div>
                  </div>
                }
                <div className='pt-3 border-t-[1px] my-10 border-[#E8E8E8] flex justify-between items-center'>
                  <div className='flex items-center gap-2 max-w-[240px] w-full'>
                    <button disabled={!selectLogTeamTwo?.data_id || loading} className='disabled:text-white  max-w-[108px] w-full font-bebas text-2xl h-[48px] bg-[#E8E8E8] text-[#4A4A4A] rounded flex justify-center items-center'>Delete</button>
                    {
                      selectLogTeamTwo &&
                      <button disabled={loading} onClick={() => [setSelectLogTeamTwo(null), setTeamTwoPlayerSelect()]} className='disabled:text-white  max-w-[108px] w-full font-bebas text-2xl h-[48px] bg-[#E8E8E8] text-[#4A4A4A] rounded flex justify-center items-center'>Cancel</button>
                    }
                  </div>
                  {
                    !selectLogTeamTwo &&
                    <button disabled={loading} onClick={() => handleAddNewScore(event_team_b_id, userTwoActionSelect, teamTwoPlayerSelect)} className='max-w-[108px] w-full font-bebas text-2xl h-[48px] bg-[#A46E40] text-white rounded flex justify-center items-center'>{loading ? "Saving" : 'Save'}</button>
                  }

                  {
                    selectLogTeamTwo &&
                    <button disabled={loading} className='max-w-[108px] w-full font-bebas text-2xl h-[48px] bg-[#A46E40] text-white rounded flex justify-center items-center'
                      onClick={() => handleActionEditPlayer(event_id, teamTwoPlayerSelect, selectLogTeamTwo.data_id)}
                    >{loading ? "Saving" : 'Save'}</button>
                  }
                </div>
              </>
            }
          </div>

        </div> : <Loading />
      }
    </>
  );
};

export default EventActionLogs;